module.exports = __webpack_public_path__ + "static/media/image-doc.42c26cd8.svg";